import React from 'react';

const NavBar = () => (
  <nav className='flex items-center justify-center flex-wrap bg-blue-800 p-5'>
    <div className='flex items-center flex-shrink-0 text-white mr-5 justify-center'>
      <span className='text-center flex justify-center items-center mr-auto font-semibold text-xl tracking-tight'>
        React Image Gallery Using Tailwind-CSS
      </span>
    </div>
  </nav>
);

export default NavBar;
